import React from "react";
import {useDispatch} from "react-redux";
import {useToasts} from "react-toast-notifications";

import {imp406Action} from "../../../../store/actions/admission";

const Imp406Link = ({admission, onHide}) => {
    const dispatch = useDispatch();
    const {addToast} = useToasts();

    const executeImp406 = () => {
        if (onHide) {
            onHide();
        }
        dispatch(imp406Action(admission, addToast));
    }

    return (
        <a className="dropdown-item pointer" onClick={executeImp406}>[IMP-406] - Reset status if no visible documents</a>
    );
}

export default Imp406Link;